class MobileNav extends HTMLElement {
  constructor() {
    super();

    this.placeholder = this.nextElementSibling;
    this.toggles = Array.from(this.querySelectorAll('[data-mobile-nav-toggle]'));
    this.panels = Array.from(this.querySelectorAll('[data-mobile-nav-panel]'));
    this.openPanelName = null;

    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', this.onToggleClick.bind(this));
    });

    this.onKeyUp = this.onKeyUp.bind(this);
    this.onResize = this.onResize.bind(this);
    document.addEventListener('keyup', this.onKeyUp);
    window.addEventListener('resize', this.onResize);

    this.watchCartCount();
  }

  disconnectedCallback() {
    document.removeEventListener('keyup', this.onKeyUp);
    window.removeEventListener('resize', this.onResize);
    if (this.cartObserver) this.cartObserver.disconnect();
  }

  getPanel(name) {
    return this.panels.find((panel) => panel.dataset.mobileNavPanel === name);
  }

  onToggleClick(event) {
    const name = event.currentTarget.dataset.mobileNavToggle;
    this.openPanelName === name ? this.close() : this.open(name);
  }

  onKeyUp(event) {
    if (event.code && event.code.toUpperCase() === 'ESCAPE' && this.openPanelName) this.close();
  }

  onResize() {
    if (this.openPanelName && window.innerWidth >= 990) this.close();
  }

  open(name) {
    const panel = this.getPanel(name);
    if (!panel) return;

    // The bar switches to position: fixed, so hold its space in the flow.
    this.placeholder.style.height = `${this.offsetHeight}px`;

    this.panels.forEach((item) => {
      item.hidden = item !== panel;
    });
    this.toggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', String(toggle.dataset.mobileNavToggle === name));
    });

    this.openPanelName = name;
    this.classList.add('is-open');
    document.body.classList.add('overflow-hidden');

    const input = panel.querySelector('input[type="search"]');
    trapFocus(panel, input || panel);
  }

  close() {
    if (!this.openPanelName) return;

    const activeToggle = this.toggles.find(
      (toggle) => toggle.dataset.mobileNavToggle === this.openPanelName
    );

    this.panels.forEach((panel) => {
      panel.hidden = true;
    });
    this.toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));

    this.openPanelName = null;
    this.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    this.placeholder.style.height = '';

    removeTrapFocus(activeToggle);
  }

  // cart.js and cart-notification.js only re-render #cart-icon-bubble in the
  // desktop markup, so mirror its count onto the mobile bar.
  watchCartCount() {
    const source = document.getElementById('cart-icon-bubble');
    const target = this.querySelector('[data-mobile-nav-cart-count]');
    if (!source || !target) return;

    const sync = () => {
      const count = source.textContent.match(/\d+/);
      target.textContent = `(${count ? count[0] : 0})`;
    };

    this.cartObserver = new MutationObserver(sync);
    this.cartObserver.observe(source, { childList: true, subtree: true, characterData: true });
    sync();
  }
}

customElements.define('mobile-nav', MobileNav);
